import {
  Children,
  cloneElement,
  FC,
  isValidElement,
  ReactElement,
} from 'react';

export const SubmitButtonWrapper: FC<{
  children: ReactElement;
  forceDisabled?: boolean;
  isForceSubmit?: boolean;
  form: any;
}> = ({ children, forceDisabled, isForceSubmit, form }) => {
  if (!form) {
    throw new Error('Form instance is required');
  }

  const child = Children.only(children);
  if (!isValidElement(child)) throw new Error('must be element');

  return (
    <form.Subscribe
      selector={(state: any) => ({
        isSubmitting: state.isSubmitting,
        canSubmit: state.canSubmit,
      })}
    >
      {({
        isSubmitting,
        canSubmit,
      }: {
        isSubmitting: boolean;
        canSubmit: boolean;
      }) => {
        const childProps: Record<string, unknown> = {
          ...(isForceSubmit ? { onClick: () => form.handleSubmit() } : {}),
          disabled: isSubmitting || (forceDisabled ?? !canSubmit),
        };

        return cloneElement(child as ReactElement, childProps);
      }}
    </form.Subscribe>
  );
};
